/** Un cadre de visée autour d'un QR : le même signe que « scanner » partout
 *  ailleurs sur un téléphone. */
export default function ScanIcon({ className = 'w-6 h-6' }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 24 24"
      className={className}
      aria-hidden="true"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M3 8V5a2 2 0 0 1 2-2h3" />
      <path d="M16 3h3a2 2 0 0 1 2 2v3" />
      <path d="M21 16v3a2 2 0 0 1-2 2h-3" />
      <path d="M8 21H5a2 2 0 0 1-2-2v-3" />
      <rect x="7.5" y="7.5" width="3.5" height="3.5" />
      <rect x="13" y="7.5" width="3.5" height="3.5" />
      <rect x="7.5" y="13" width="3.5" height="3.5" />
      <path d="M13 13h3.5v3.5" />
    </svg>
  );
}
